<rt-select
  [options]="options()"
  [includeEmptyOption]="false"
  [hasInputTrigger]="true"
  [optionTemplate]="option"
  [triggerTemplate]="trigger"
  [disabled]="isDisabled()"
  [readOnly]="isReadOnly()"
  [value]="value"
  (valueChange)="valueChange.emit($event)"
/>

<ng-template #option let-option="option">
  <span layout layout-align-items-center>
    <rt-avatar
      [type]="option?.hasAvatar ? 'image' : 'initials'"
      [initials]="$safeNavigationMigration(option?.initials)"
      size="small-x"
      [imageSrc]="option.photoThumbUrl"
      context="admin"
      margin-right-small
    />{{ option.label }}
  </span>
</ng-template>

<ng-template
  #trigger
  let-selectedOption="selectedOption"
  let-dropdownOpened="dropdownOpened"
  let-toggleDropdown="toggleDropdown"
>
  <div layout class="trigger-wrapper">
    <rt-input
      #inputTrigger
      [class.empty]="!selectedOption?.value"
      [hasDropdownIndicator]="!isReadOnly() && !selectedOption?.value"
      [disabled]="isDisabled()"
      [readOnly]="isReadOnly()"
      [invalid]="isInvalid()"
      [class.dropdownOpened]="dropdownOpened"
      [hasClearButton]="!!selectedOption?.value && !isDisabled() && !isReadOnly()"
      [placeholder]="'rtu.ui.select.placeholder' | translate"
      [value]="
        isUserDeleted()
          ? ('app.common.deleted_user' | translate)
          : selectedOption?.value && selectedOption?.label
      "
      (click)="isDisabled() || isReadOnly() ? null : toggleDropdown()"
      (reset)="inputTrigger.setBlur(); clearInput($event)"
      variant="rounded"
      class="trigger"
    >
      @if (value) {
        <rt-avatar
          prefix
          [type]="isUserDeleted() ? 'icon' : selectedOption?.hasAvatar ? 'image' : 'initials'"
          [initials]="$safeNavigationMigration(selectedOption?.initials)"
          size="small-x"
          [imageSrc]="$safeNavigationMigration(selectedOption?.photoThumbUrl)"
          context="admin"
          iconName="person"
        />
      }
    </rt-input>
  </div>
</ng-template>
